import api from "../../Environment";
import { normalizePresentation } from "./experienceHelpers";

/**
 * Phase B — thin Experience / Dynamic Page API client.
 */

/**
 * Resolve Admin-configured destination experience (guide, login, …).
 */
export async function fetchDestinationExperience(destinationType) {
  const type = destinationType && String(destinationType).trim();
  if (!type) {
    return null;
  }
  try {
    const response = await api.postMethod("experience/destination", {
      destination_type: type,
    });
    const body = response && response.data;
    if (body && body.success && body.data) {
      if (body.data.experience_enabled !== true) {
        return normalizePresentation(null);
      }
      return normalizePresentation(body.data.experience);
    }
  } catch (e) {
    /* ignore */
  }
  return null;
}

export async function fetchSectionTypes() {
  try {
    const response = await api.postMethod("experience/section-types", {});
    const body = response && response.data;
    if (body && body.success && body.data) {
      return body.data.types || [];
    }
  } catch (e) {
    /* ignore */
  }
  return [];
}

export async function fetchExperiencePage(slug) {
  if (!slug) {
    return null;
  }
  try {
    const response = await api.postMethod("experience/page", { slug });
    const body = response && response.data;
    if (body && body.success) {
      return body.data || null;
    }
  } catch (e) {
    /* ignore */
  }
  return null;
}

export async function fetchDynamicPage(params = {}) {
  try {
    const response = await api.postMethod("pages/dynamic", params);
    const body = response && response.data;
    if (body && body.success) {
      return body.data || null;
    }
  } catch (e) {
    /* ignore */
  }
  return null;
}

export async function fetchLandingBridge(params = {}) {
  try {
    const response = await api.postMethod("pages/landing", params);
    const body = response && response.data;
    if (body && body.success && body.data) {
      return body.data;
    }
  } catch (e) {
    /* ignore */
  }
  return { managed: false, empty: true, page: null, preserve_url: true };
}

/**
 * Map resolved section DTOs to a simple render list.
 */
export function mapPageSections(page) {
  if (!page || !Array.isArray(page.sections)) {
    return [];
  }
  return page.sections.map((section) => ({
    id: section.id,
    type: section.type,
    label: section.label,
    implemented: !!section.implemented,
    // Virtual defaults may only ship config; prefer payload then config.
    payload: section.payload || section.config || {},
  }));
}
